




import Vue from 'vue'
import Component from 'vue-class-component'
import Loading from './Loading.vue'

@Component({
  props: {
    id: {
      type: String,
      default: 'Root'
    }
  },
  components: {
    Loading
  }
})
export default class LoadingBar extends Vue {
  message: string = ''
  loading: boolean = false

  enableLoading (options: { message: string, id?: string }) {
    options.id = options.id || 'Root'
    if (this.$props.id === options.id) {
      this.message = options.message
      this.loading = true
      document.body.classList.add('modal-opened')
    }
  }

  disableLoading (options: { id: string } = { id: 'Root' }) {
    if (this.$props.id === options.id) {
      this.message = ''
      this.loading = false
      document.body.classList.remove('modal-opened')
    }
  }

  mounted () {
    this.$eventBus.$on('loading:enable', this.enableLoading)
    this.$eventBus.$on('loading:disable', this.disableLoading)
  }

  beforeDestroy () {
    this.$eventBus.$off('loading:enable', this.enableLoading)
    this.$eventBus.$off('loading:disable', this.disableLoading)
  }
}
